import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeContractTempDTO  {
    _originalTypeClassName = "zERP.BO.EmployeeContractTempDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeContractTempDTO.translate = translateService;
}
this.Id = null;
this.IsActive = false;
this.StartDate = null;
this.EndDate = null;
this.Type = null;
this.RelationshipType = null;
this.Salary = null;
this.ContractTerminationDate = null;
this.Kind = null;
this.CompensationAmount = null;
this.AdvancePaymentAmount = null;
this.TotalPayrollPeriods = null;
this.CostCenterFrom = null;
this.CostCenterTo = null;
this.Manager = false;
this.IsSupervisor = false;
this.EligibilityStatementEnd = null;
this.EligibilityStatementStart = null;
this.EligibilityStatement = false;
this.HazardCategoryStart = null;
this.HazardCategoryEnd = null;
this.SalaryNew = null;
this.OverrideSalaryPeriodsConfig = false;
this.ProtiMeraOraProslipsis = null;
this.ProtiMeraOraApoxorisis = null;
this.UnderageCardCode = null;
this.EmploymentProperty = null;
this.EmploymentSpecialCase = null;
this.EmploymentResponsiblePosition = null;
this.E3AdditionalStaffTableCode = null;
this.E3AdditionalStaffTableDate = null;
this.E3Comments = null;
this.FlexibleArrivalInMinutes = null;
this.HasWorkingCard = false;
this.IsFirstTimeSalaried = false;
this.Employee = null;
this.TerminationReason = null;
this.Entity = null;
this.Template = null;
this.CompensationCalculatedExpression = null;
this.Department = null;
this.Supervisor = null;
this.Branch = null;
this.AccountingConfig = null;
this.PayrollCategory = null;
this.PayrollCategoryLevel = null;
this.ProfessionSpecialization = null;
this.Location = null;
this.Floor = null;
this.DepartmentFloor = null;
this.Institution = null;
this.CostCenter = null;
this.WorkProgram = null;
this.Position = null;
this.HazardCategory = null;
this.Direction = null;
this.GroupEmployee = null;
this.DypaProperties = null;
this.ResidencePermit = null;
this.SepeSpecialization = null;
this.EmploymentStatistics = null;
this.WorkProgramFile = null;
this.MainSalaries = null;
this.BasicSalaries = null;
this.OtherSalaries = null;
this.Contributions = null;
this.Deductions = null;
this.PayrollCategoryHistory = null;
this.Documents = null;
this.SalaryPeriods = null;
this.EmployeeContractHistory = null;
this.LeaveTypes = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsActive:any;
StartDate:any;
EndDate:any;
Type:any;
RelationshipType:any;
Salary:any;
ContractTerminationDate:any;
Kind:any;
CompensationAmount:any;
AdvancePaymentAmount:any;
TotalPayrollPeriods:any;
CostCenterFrom:any;
CostCenterTo:any;
Manager:any;
IsSupervisor:any;
EligibilityStatementEnd:any;
EligibilityStatementStart:any;
EligibilityStatement:any;
HazardCategoryStart:any;
HazardCategoryEnd:any;
SalaryNew:any;
OverrideSalaryPeriodsConfig:any;
ProtiMeraOraProslipsis:any;
ProtiMeraOraApoxorisis:any;
UnderageCardCode:any;
EmploymentProperty:any;
EmploymentSpecialCase:any;
EmploymentResponsiblePosition:any;
E3AdditionalStaffTableCode:any;
E3AdditionalStaffTableDate:any;
E3Comments:any;
FlexibleArrivalInMinutes:any;
HasWorkingCard:any;
IsFirstTimeSalaried:any;
Employee:any;
TerminationReason:any;
Entity:any;
Template:any;
CompensationCalculatedExpression:any;
Department:any;
Supervisor:any;
Branch:any;
AccountingConfig:any;
PayrollCategory:any;
PayrollCategoryLevel:any;
ProfessionSpecialization:any;
Location:any;
Floor:any;
DepartmentFloor:any;
Institution:any;
CostCenter:any;
WorkProgram:any;
Position:any;
HazardCategory:any;
Direction:any;
GroupEmployee:any;
DypaProperties:any;
ResidencePermit:any;
SepeSpecialization:any;
EmploymentStatistics:any;
WorkProgramFile:any;
MainSalaries:any;
BasicSalaries:any;
OtherSalaries:any;
Contributions:any;
Deductions:any;
PayrollCategoryHistory:any;
Documents:any;
SalaryPeriods:any;
EmployeeContractHistory:any;
LeaveTypes:any;

static assignPreviousContract($this: any, cont: any): any{let temp = [];
$this.IsActive = cont?.IsActive;
$this.StartDate = cont?.StartDate;
$this.EndDate = cont?.EndDate;
$this.Type = cont?.Type;
$this.RelationshipType = cont?.RelationshipType;
$this.Salary = cont?.Salary;
$this.ContractTerminationDate = cont?.ContractTerminationDate;
$this.Kind = cont?.Kind;
$this.CompensationAmount = cont?.CompensationAmount;
$this.AdvancePaymentAmount = cont?.AdvancePaymentAmount;
$this.TotalPayrollPeriods = cont?.TotalPayrollPeriods;
$this.CostCenterFrom = cont?.CostCenterFrom;
$this.CostCenterTo = cont?.CostCenterTo;
$this.Manager = cont?.Manager;
$this.IsSupervisor = cont?.IsSupervisor;
$this.EligibilityStatementEnd = cont?.EligibilityStatementEnd;
$this.EligibilityStatementStart = cont?.EligibilityStatementStart;
$this.EligibilityStatement = cont?.EligibilityStatement;
$this.HazardCategoryStart = cont?.HazardCategoryStart;
$this.HazardCategoryEnd = cont?.HazardCategoryEnd;
$this.OverrideSalaryPeriodsConfig = cont?.OverrideSalaryPeriodsConfig;
$this.ProtiMeraOraProslipsis = cont?.ProtiMeraOraProslipsis;
$this.ProtiMeraOraApoxorisis = cont?.ProtiMeraOraApoxorisis;
$this.UnderageCardCode = cont?.UnderageCardCode;
$this.EmploymentProperty = cont?.EmploymentProperty;
$this.EmploymentSpecialCase = cont?.EmploymentSpecialCase;
$this.EmploymentResponsiblePosition = cont?.EmploymentResponsiblePosition;
$this.E3AdditionalStaffTableCode = cont?.E3AdditionalStaffTableCode;
$this.E3AdditionalStaffTableDate = cont?.E3AdditionalStaffTableDate;
$this.E3Comments = cont?.E3Comments;
$this.FlexibleArrivalInMinutes = cont?.FlexibleArrivalInMinutes;
$this.HasWorkingCard = cont?.HasWorkingCard;
$this.IsFirstTimeSalaried = cont?.IsFirstTimeSalaried;
$this.Employee = cont?.Employee?.Id;
$this.TerminationReason = cont?.TerminationReason?.Id;
$this.Entity = cont?.Entity?.Id;
$this.Template = cont?.Template?.Id;
$this.CompensationCalculatedExpression = cont?.CompensationCalculatedExpression?.Id;
$this.Department = cont?.Department?.Id;
$this.Supervisor = cont?.Supervisor?.Id;
$this.Branch = cont?.Branch?.Id;
$this.AccountingConfig = cont?.AccountingConfig?.Id;
$this.PayrollCategory = cont?.PayrollCategory?.Id;
$this.PayrollCategoryLevel = cont?.PayrollCategoryLevel?.Id;
$this.ProfessionSpecialization = cont?.ProfessionSpecialization?.Id;
$this.Location = cont?.Location?.Id;
$this.Floor = cont?.Floor?.Id;
$this.DepartmentFloor = cont?.DepartmentFloor?.Id;
$this.Institution = cont?.Institution?.Id;
$this.CostCenter = cont?.CostCenter?.Id;
$this.WorkProgram = cont?.WorkProgram?.Id;
$this.Position = cont?.Position?.Id;
$this.HazardCategory = cont?.HazardCategory?.Id;
$this.Direction = cont?.Direction?.Id;
$this.GroupEmployee = cont?.GroupEmployee?.Id;
$this.DypaProperties = cont?.DypaProperties?.Id;
$this.ResidencePermit = cont?.ResidencePermit?.Id;
$this.SepeSpecialization = cont?.SepeSpecialization?.Id;
$this.EmploymentStatistics = cont?.EmploymentStatistics?.Id;
$this.WorkProgramFile = cont?.WorkProgramFile?.Id;
for (let _iitem = 0; _iitem < (cont?.MainSalaries == null ? 0 : cont?.MainSalaries.length); _iitem++) {let item = cont?.MainSalaries[_iitem];temp?.add(item?.Id?.toString());}
$this.MainSalaries = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (cont?.BasicSalaries == null ? 0 : cont?.BasicSalaries.length); _iitem++) {let item = cont?.BasicSalaries[_iitem];temp?.add(item?.Id?.toString());}
$this.BasicSalaries = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (cont?.OtherSalaries == null ? 0 : cont?.OtherSalaries.length); _iitem++) {let item = cont?.OtherSalaries[_iitem];temp?.add(item?.Id?.toString());}
$this.OtherSalaries = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (cont?.Contributions == null ? 0 : cont?.Contributions.length); _iitem++) {let item = cont?.Contributions[_iitem];temp?.add(item?.Id?.toString());}
$this.Contributions = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (cont?.Deductions == null ? 0 : cont?.Deductions.length); _iitem++) {let item = cont?.Deductions[_iitem];temp?.add(item?.Id?.toString());}
$this.Deductions = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (cont?.PayrollCategoryHistory == null ? 0 : cont?.PayrollCategoryHistory.length); _iitem++) {let item = cont?.PayrollCategoryHistory[_iitem];temp?.add(item?.Id?.toString());}
$this.PayrollCategoryHistory = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (cont?.Documents == null ? 0 : cont?.Documents.length); _iitem++) {let item = cont?.Documents[_iitem];temp?.add(item?.Id?.toString());}
$this.Documents = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (cont?.SalaryPeriods == null ? 0 : cont?.SalaryPeriods.length); _iitem++) {let item = cont?.SalaryPeriods[_iitem];temp?.add(item?.Id?.toString());}
$this.SalaryPeriods = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (cont?.LeaveTypes == null ? 0 : cont?.LeaveTypes.length); _iitem++) {let item = cont?.LeaveTypes[_iitem];temp?.add(item?.Id?.toString());}
$this.LeaveTypes = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}